const devConfig = {
    BASE_URL: "https://api.tameen.om",
    OCR_BASE_URL: "https://ocr.tameen.om",
    CHANNEL_PARTNER_URL: "https://channelpartner.tameen.om/",
    INSURANCE_API: "https://api.tameen.om",
    TAMEEN_STAGING: "https://staging.tameen.om",
    databaseURL: "https://insuranceinbox-auth-staging.firebaseio.com",
    CHANNEL_PARTNER_INSURER: 'https://channelpartner.tameen.om',
    PAYMENT_URL: 'https://payments.tameen.om',
    ADMIN_ENDORSEMENT_ROUTE: '/manage/endorsementlist',
    CDN_URL: 'https://storage.tameen.om/tameen/newtm/'
}
export default devConfig;